import { BreadCrumbElement } from '@/models/bread-crumb-element';

class AuthStorageService {
  public readonly ADMIN_AUTH_TOKEN = 'Admin-Auth-Token';
  public readonly OAUTH_STATE = 'oauth_state';
  public readonly OAUTH_CODE_VERIFIER = 'oauth_code_verifier';

  public set breadCrumbMenu(value: BreadCrumbElement[]) {
    localStorage.setItem('bread-crumb-menu', JSON.stringify(value));
  }

  public get breadCrumbMenu(): BreadCrumbElement[] {
    const value = localStorage.getItem('bread-crumb-menu');
    return value ? JSON.parse(value) : null;
  }

  public set adminAuthToken(value: string) {
    sessionStorage.setItem(this.ADMIN_AUTH_TOKEN, value);
  }

  public get adminAuthToken(): string {
    return sessionStorage.getItem(this.ADMIN_AUTH_TOKEN);
  }

  /**
   * Admin Auth Tokenを削除する
   */
  public removeAdminAuthToken() {
    sessionStorage.removeItem(this.ADMIN_AUTH_TOKEN);
  }

  public get existsAdminAuthToken(): boolean {
    return !!sessionStorage.getItem(this.ADMIN_AUTH_TOKEN);
  }

  /**
   * OAuth2 関連
   * - oauth_state          OAuthサーバーとの通信で使用 /callback で検証する
   * - oauth_code_verifier  PKCE: APIに渡し、APIがOAuthサーバーとの通信で使用
   */
  // oauth_state
  public set oauthState(value: string) {
    sessionStorage.setItem(this.OAUTH_STATE, value);
  }
  public get oauthState(): string {
    return sessionStorage.getItem(this.OAUTH_STATE);
  }
  // oauth_code_verifier
  public set oauthCodeVerifier(value: string) {
    sessionStorage.setItem(this.OAUTH_CODE_VERIFIER, value);
  }
  public get oauthCodeVerifier(): string {
    return sessionStorage.getItem(this.OAUTH_CODE_VERIFIER);
  }
  // OAuth に関するデータを削除
  public removeOauthItems() {
    sessionStorage.removeItem(this.OAUTH_STATE);
    sessionStorage.removeItem(this.OAUTH_CODE_VERIFIER);
  }
}

export const storageService = new AuthStorageService();
